(() => {
  const initialize = root => {
  if (!root || root.dataset.ready) return;
  const source = root.querySelector('[data-sc-review-source]')?.content;
  const feed = source?.querySelector('#loox-reviews-feed');
  const items = Array.from(feed?.querySelectorAll('.loox-review') || []);
  const summary = feed?.querySelector('.loox-ssr-review-summary')?.textContent.match(/([\d.]+)\s*\/\s*5\s+from\s+([\d,]+)\s+reviews/i);
  const grid = root.querySelector('[data-sc-review-cards]');
  const native = root.querySelector('[data-sc-review-native]');
  if (!items.length || !summary || !grid || !native) return;
  const average = Number(summary[1]);
  const total = Number(summary[2].replace(/,/g, ''));
  if (!(average >= 0 && average <= 5 && total > 0)) return;

  root.scEvents = new AbortController();
  const eventOptions = { signal: root.scEvents.signal };
  const text = (element, selector) => element.querySelector(selector)?.textContent.trim() || '';
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const stars = (rating, className) => {
    const node = element('span', className);
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', `${rating.toLocaleString('de-DE')} von 5 Sternen`);
    const track = element('span', 'sc-reviews__stars-track', '★★★★★');
    track.setAttribute('aria-hidden', 'true');
    const fill = element('span', 'sc-reviews__stars-fill', '★★★★★');
    fill.setAttribute('aria-hidden', 'true');
    fill.style.width = `${rating / 5 * 100}%`;
    node.append(track, fill);
    return node;
  };
  const reviewUrl = href => {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return null;
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };

  // Validate the whole source before enhancing; never silently omit a review.
  const records = items.map(item => ({
    item,
    name: text(item, '.loox-reviewer-name'),
    body: text(item, '.loox-review-body'),
    rating: Number(text(item, '.loox-review-rating').split('/')[0]),
    id: item.dataset.reviewId
  }));
  if (records.some(record => !record.name || !record.id || !(record.rating >= 1 && record.rating <= 5))) return;

  const cards = records.map(({ item, name, body, rating, id }) => {
    const card = element('article', 'sc-review');
    card.dataset.reviewId = id;
    const top = element('div', 'sc-review__top');
    top.append(element('strong', 'sc-review__author', name));
    if (item.querySelector('.loox-review-verified')) top.append(element('span', 'sc-review__verified', '✓ Verifiziert'));
    card.append(top, stars(rating, 'sc-review__rating'));
    const dateSource = item.querySelector('.loox-review-date');
    if (dateSource) {
      const date = new Date(dateSource.dateTime);
      const time = element('time', 'sc-review__date', Number.isNaN(date.getTime()) ? dateSource.textContent.trim() : date.toLocaleDateString('de-DE', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/Berlin' }));
      time.dateTime = dateSource.dateTime;
      card.append(time);
    }
    if (body) card.append(element('p', 'sc-review__body', body));
    const image = item.querySelector('.loox-review-image');
    const mediaHref = item.querySelector('.loox-review-media-link')?.getAttribute('href');
    const url = mediaHref && reviewUrl(mediaHref);
    if (image && url) {
      const media = element('a', 'sc-review__media');
      media.href = url.href;
      media.rel = 'nofollow';
      media.setAttribute('aria-label', `Kundenfoto von ${name} ansehen`);
      const photo = image.cloneNode(false);
      photo.removeAttribute('class');
      photo.alt = `Kundenfoto von ${name}`;
      media.append(photo);
      media.addEventListener('click', event => {
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && typeof window.LOOX?.openQV === 'function') {
          event.preventDefault();
          window.LOOX.openQV(id);
        }
      });
      card.append(media);
    }
    const reply = item.querySelector('.loox-review-reply, .loox-review-merchant-reply');
    if (reply) card.append(element('p', 'sc-review__reply', `Antwort von SNIFFCAR: ${reply.textContent.trim()}`));
    return card;
  });
  grid.replaceChildren(...cards);

  const score = root.querySelector('[data-sc-review-score]');
  const countLink = element('a', 'sc-reviews__count', `${total.toLocaleString('de-DE')} Bewertungen`);
  countLink.href = '#looxReviews';
  score.append(element('strong', 'sc-reviews__average', `${average.toLocaleString('de-DE')} / 5`), stars(average, 'sc-reviews__stars'), countLink);


  const more = root.querySelector('[data-sc-review-more]');
  const pageSize = Number(root.dataset.pageSize) || 6;
  let visible = pageSize;
  const updateVisible = () => {
    cards.forEach((card, index) => { card.hidden = index >= visible; });
    more.hidden = visible >= cards.length;

  };
  more.addEventListener('click', () => {
    const next = cards[visible];
    visible = Math.min(visible + pageSize, cards.length);
    updateVisible();
    root.querySelector('[data-sc-review-status]').textContent = `${visible} Bewertungen angezeigt.`;
    if (next) {
      next.tabIndex = -1;
      next.focus({ preventScroll: true });
    }
  });
  const writeLink = root.querySelector('[data-sc-review-write]');
  const writeUrl = reviewUrl(writeLink.getAttribute('href'));
  if (writeUrl) writeLink.href = writeUrl.href;
  writeLink.addEventListener('click', event => {
    if (typeof window.LOOX?.showReviewForm === 'function') {
      event.preventDefault();
      window.LOOX.showReviewForm(root.dataset.productId);
    }
  });

  // Preserve the existing rating links at the top of the product page.
  const isNativeHash = hash => hash === '#looxReviews' || hash === '#looxReviewsFrame';
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && url.pathname === window.location.pathname && isNativeHash(url.hash)) native.open = true;
  }, eventOptions);
  window.addEventListener('hashchange', () => { if (isNativeHash(window.location.hash)) native.open = true; }, eventOptions);

  updateVisible();
  root.querySelector('.sc-reviews__summary').hidden = false;
  grid.hidden = false;
  root.dataset.ready = 'true';
  root.classList.add('is-ready');
  native.open = isNativeHash(window.location.hash);
  // This heading belonged to the original lower review widget only.
  const oldHeading = document.querySelector('[id$="__rich_text_kckhUA"]');
  if (oldHeading) oldHeading.hidden = true;
  };
  document.querySelectorAll('.sc-reviews').forEach(initialize);
  if (!window.scNativeReviewEvents) {
    window.scNativeReviewEvents = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sc-reviews').forEach(initialize));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.sc-reviews').forEach(root => root.scEvents?.abort()));
  }
})();
